/**
 *
 * index
 *
 */

import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from 'lib/serviceWorker';

// router
import { Router } from 'react-router-dom';
import { history } from 'lib/history';
import { QueryParamsProvider } from '@domonda/query-params';

// polyfills
import 'lib/polyfills';

// intl
import { IntlProvider } from 'lib/intl/IntlContext';
import { messages } from 'core/translations/messages';

// styles
import { createTheme, createPalette, ThemeProvider, Baseline } from '@domonda/ui';

const theme = createTheme({
  palette: createPalette({
    default: '#3f3f3f',
    primary: '#00aae9',
    secondary: '#25c1b4',
    textPrimary: '#000000',
    textSecondary: '#a7a7a7',
    textLight: '#ffffff',
    success: '#02bb44',
    error: '#cc0000',
    warning: '#fda50d',
    border: '#d8d8d8',
    background: '#f3f4f8',
    surface: '#ffffff',
  }),
});

// parts
import { Root } from 'core/Root';

ReactDOM.render(
  <Router history={history}>
    <IntlProvider messages={messages}>
      <ThemeProvider theme={theme}>
        <Baseline />
        <QueryParamsProvider history={history}>
          <Root />
        </QueryParamsProvider>
      </ThemeProvider>
    </IntlProvider>
  </Router>,
  document.getElementById('root'),
);

serviceWorker.register();
